
class Index extends SlotGame.src.component.ReelsetComponent {
    public MIN_SPIN_DURATION = 250;
    public TIME_STOP_DELAY = 150;

    protected currentSpinId = 0;

    async startRotate(): Promise<void> {
        this.currentSpinId++;
        return super.startRotate();
    }

    async stopRotate(): Promise<void> {

        return super.stopRotate();
    }

    checkReplaceSymbols(): Boolean {
        return false;
    }

    async onIdleWaitSpin() {
        if (this.store.gameData.hasWins()) {
            this.playAllWinLinesLoopAnimation();
        } else {
            this.playAllIdleAnimation();
        }

        await this.waitClick();
    }

    checkShowWinShowAllWins() {
        return this.store.gameData.hasLineWins() || this.store.gameData.hasWaysWins() || this.store.gameData.hasPositionsWins();
    }

    checkShowWinShowWinLines() {
        return false;
    }

    playAllWinLinesLoopAnimation() {
        const lines = [...this.store.gameData.lines];

        // Добавляем positions в список кольок если ваелды не перекрывают
        if (!this.store.gameData.hasReplace()) {
            lines.push(...this.store.gameData.positions);
        } else {
            if (this.store.gameData.positions.length) {
                this.store.gameData.positions.forEach((data) => {
                    let isFinded = false;

                    data.positions.forEach(([x, y]) => {
                        const index = this.store.gameData.replace.findIndex((replaceData) => replaceData.x == x && replaceData.y == y);
                        if (index >= 0) {
                            isFinded = true;
                        }
                    });

                    if (!isFinded) {
                        lines.push(data);
                    }
                })
            }
        }

        let currLineIndex = -1;
        const lastSpinId = this.currentSpinId;
        const playNextWinLine = async () => {
            //@ts-ignore
            if (this.isSkipped ||
                this.state != this.STATES.IDLE ||
                !this.store.gameData.hasWins() ||
                lastSpinId !== this.currentSpinId) return;

            const line = lines[++currLineIndex];
            game.emit(ReelsetComponent.events.SHOW_LINE, lines[currLineIndex]);
            this.playAllLoseAnimation();
            await this.showWins(line.positions);

            if (currLineIndex >= lines.length - 1) {
                currLineIndex = -1;
            }

            await playNextWinLine();
        }

        if (lines.length > 0 && !this.store.autoplay.isActive) {
            playNextWinLine();
        }

    }

    checkShowWinShowWinPositions() {
        return false;
    }


    checkShowWinShowWinScatters() {
        return this.store.gameData.hasPositionsWins() && this.store.gameData.hasReplace();
    }

    async onShowWinShowWinScatters() {
        await super.onShowWinShowWinPositions();
        this.playAllIdleAnimation();
    }


    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            SHOW_WIN: {
                ...super.getFSMHandlers()["SHOW_WIN"],

                showWinScatters: {
                    on: this.onShowWinShowWinScatters.bind(this),
                    check: this.checkShowWinShowWinScatters.bind(this)
                }
            },
            GAMBLE: {
                hide: {
                    on: () => {
                        this.playAllIdleAnimation();
                    }
                },
                showLoseResult: {
                    on: () => {
                        this.playAllIdleAnimation();
                    }
                }
            }
        }
    }
}

// @ts-ignore
Game.src.component.ReelsetComponent = Index
